<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="txbxshortName">Name</label>
                    <input id="txbxName" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
                <div class="form-group">
                    <label for="cbxAssignedRole">Auto-Assign To</label>
                    <wj-combo-box
                        id="cbxAssignedRole"
                        [(ngModel)]="target.assignedRole"
                        name="assignedRole"
                        [itemsSource]="roleOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
